import Vue from 'vue/dist/vue.esm.js'
import axios from 'axios'

export class SearchColumn {
  constructor() {
    if (document.getElementById('js-column_search') == null) return
    axios.get('/wp-json/wp/v2/custom/column').then(function (res) {
      const vm = new Vue({
        el: '#vue-column-search',
        data: {
          posts: res.data,
          column_cat: vueCats,
        },
        computed: {
          filteredPosts: function () {
            let posts = this.posts.filter((post) => {
              let zenbuCheckSaretenai = true
              let kijiniHitotsudemoCategoryGaGaitousuru = false

              this.column_cat.forEach((cat) => {
                if (cat.checked) {
                  zenbuCheckSaretenai = false
                  if (post.column_cat.includes(cat.slug)) {
                    kijiniHitotsudemoCategoryGaGaitousuru = true
                  }
                }
              })
              if (zenbuCheckSaretenai) {
                return true
              } else {
                if (kijiniHitotsudemoCategoryGaGaitousuru) {
                  return true
                } else {
                  return false
                }
              }
            })
            return posts.length
          },
        },
        mounted() {
          this.column_cat.forEach((term) => {
            if (term.checked) {
              this.currentCat = term.slug
            }
          })
        },
        methods: {
          toggleCheck: function (item) {
            item.checked = !item.checked
          },
          changeCat: function () {
            this.column_cat.forEach((term) => {
              if (term.slug == this.currentCat) {
                term.checked = true
              } else {
                term.checked = false
              }
            })
          },
        },
      })
    })
  }
}
